import { Component, Input, ViewEncapsulation } from '@angular/core';
import { JeanFlight, TripProductType, WizumenProduct } from '../wizumen-models';

//Cards de productos comprados
@Component({
  selector: 'wizumen-bought-product',
  template: `
    <div class="wizumen-product eva-3-card -eva-3-shadow-line flex align-center">
        <i class="eva-3-icon-{{item.icon}} eva-icon -eva-3-tc-brand-primary-4 principal-eva-icon"></i>
        <span class="wizumen-product-content">
            <p class="wizumen-product-title -eva-3-bold -eva-3-ellipsis">{{item.name}}</p>
            <div class="wizumen-product-detail">
                
                <span class="wizumen-product-detail-item">
                    <i class="eva-3-icon-calendar eva-icon"></i>
                    <em class="wizumen-product-detail-item-text">
                        {{getFormattedFromToDate()}}
                    </em>
                </span>

                <span *ngIf="item.passengers" class="wizumen-product-detail-item">
                    <i class="eva-3-icon-users eva-icon"></i>
                    <em class="wizumen-product-detail-item-text"> {{item.passengers}}</em>
                </span>
                <span *ngIf="item.rooms" class="wizumen-product-detail-item">
                    <i class="eva-3-icon-bed eva-icon"></i>
                    <em class="wizumen-product-detail-item-text"> {{item.rooms}}</em>
                </span>
                <span *ngIf="item.from_time" class="wizumen-product-detail-item">
                    <i class="eva-3-icon-time eva-icon"></i>
                    <em class="wizumen-product-detail-item-text"> {{item.from_time}}</em>
                </span>

            </div>
        </span>
    </div>
  `,
  styleUrls: ['../wizumen.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizumenBoughtProductComponent {
  @Input() item: WizumenProduct;

  getFormattedFromToDate(): string {
    if(this.item.type !== TripProductType.FLIGHT || (this.item.type === TripProductType.FLIGHT && (this.item.product as JeanFlight).round_trip)) {
        return `${this.item.formatted_from_date} - ${this.item.formatted_to_date}`;
    }
    return this.item.formatted_from_date;
  }
}